import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './payment.css';


class PaymentIni extends Component {
constructor(props) {
    super(props);
}
      
  render() {
    return (
        <div className="m-grid m-grid--hor m-grid--root m-page">
            <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--singin m-login--2 m-login-2--skin-2" id="m_login" style={{ backgroundImage: "url(../../../assets/app/media/img/bg/new-background.png)"}}>
                <div className="m-grid__item m-grid__item--fluid m-login__wrapper">
                    <div className="m-login__container">
                        <div className="m-login__logo">
                            <a href="#">
                                <img src="../../../assets/app/media/img/logos/petpos-logo2.png" style={{width: '230px'}}/>
                            </a>
                        </div>
                        <div className="m-login__signin">
                            <div className="m-login__head">
                                <h3 className="m-login__title">
                                    Add Card
                                </h3>
                            </div>
                            <form className="m-form m-form--fit m-form--label-align-right">
                                 <div className="m-portlet__body" style={{backgroundColor: 'white'}}>
                                    <div className="col-xl-12 py-4">
                                            <span className="m-topbar__userpic" style={{display:'flex', justifyContent:'flex-end'}}>
                                                <img src="../../../assets/app/media/img/payment/sample_cards.jpg" alt="" />
                                                </span>
                                            <div className="col-xl-12 p-0">
                                            <div className="form-group">
                                                <label for="card-number" className="form-control-label">Card Number</label>
                                                <input type="text" className="form-control" id="date-of-create" placeholder="4242 0000 4321 9876"/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xl-6 col-sm-12">
                                                <div className="form-group">
                                                    <label for="expiration-date" className="form-control-label">Expiration Date</label>
                                                    <input type="text" className="form-control" id="expiration-date" placeholder="04 / 20"/>
                                                </div>
                                            </div>
                                            <div className="col-xl-6 col-sm-12">
                                                <div className="form-group">
                                                    <label for="security-code" className="form-control-label">Security Code</label>
                                                    <input type="text" className="form-control" id="security-code" placeholder="123"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="m-login__form-action">
                                            <div className="row">
                                                <div className="col-12">
                                                    <button type="submit" id="m_login_signin_submit" className="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air  m-login__btn pull-right ml-2">Submit</button>
                                                        <button type="submit" id="m_login_signup" className="btn btn-outline-focus m-btn--pill pull-right">Back</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                
    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});

export default withRouter(connect(mapStateToProps)(PaymentIni));